import { render, staticRenderFns } from "./SectionItemPost.vue?vue&type=template&id=1969b4f2&lang=pug&"
import script from "./SectionItemPost.vue?vue&type=script&lang=js&"
export * from "./SectionItemPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports